<template>
  <v-data-table
    :headers="headers"
    :items="questions"
    sort-by="queries"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-alert :value="true" dense outlined type="error" v-if="error">
        {{ error }}
      </v-alert>
      <v-alert :value="true" dense outlined type="success" v-if="message">
        {{ message }}
      </v-alert>
      <v-toolbar flat>
        <v-toolbar-title>Kysymykset</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="750px">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      label="Kysymys"
                      prepend-icon="mdi-information-variant"
                      v-model="questionItems.questionDescription"
                      autocomplete="off"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      prepend-icon="mdi-account-supervisor"
                      v-model="questionItems.questionState"
                      :items="questionStates"
                      label="Kyselyn tila"
                      placeholder="Valitse"
                      item-text="name"
                      item-value="value"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" text @click="save">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
    </template>
  </v-data-table>
</template>
<script>
import QuestionService from '@/services/PowerGuard/QuestionService.js';

export default {
  data() {
    return {
      questions: [],
      dialog: false,
      error: null,
      message: null,
      formTitle: 'Muokkaa käyttäjän tietoja',
      headers: [
        { text: 'Kysymys', value: 'questionDescription' },
        { text: 'Tila', value: 'questionState' },
        {
          text: 'Muuta',
          value: 'actions',
          sortable: false,
        },
      ],
      questionStates: [
        { name: 'Aktiivinen', value: 'active' },
        {
          name: 'Passiivinen',
          value: 'passive',
        },
      ],
      questionItems: {
        questionDescription: '',
        questionState: '',
      },
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  async created() {
    const response = await QuestionService.getAllQuestions();
    this.questions = response.data.questions;
  },

  methods: {
    editItem(item) {
      this.questionItems = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.questionItems = Object.assign({}, this.questions);
      });
    },

    async save() {
      try {
        console.log(this.questionItems);
        const response = await QuestionService.saveQueryModification(
          this.questionItems
        );
        this.message = response.data.message;
        this.error = response.data.error;
        const questions = await QuestionService.getAllQueries();
        this.questions = questions.data.questions;
        this.close();
        setTimeout(() => {
          this.message = null;
          this.error = null;
        }, 3000);
      } catch (error) {
        this.close();
        this.error = 'Jokin meni vikaan';
        setTimeout(() => {
          this.error = null;
        });
      }
    },
  },
};
</script>
<style></style>
